import { LevelType } from 'data/types';
import { collectDuctedLayoutSpaces } from 'utils/ducted-layout-configuration';

export function countDuctedDesignLevels(structure: LevelType[]): number {
  const levelUniqueIds = new Set(
    collectDuctedLayoutSpaces(structure).map(({ level }) => level.uniqueId)
  );
  return levelUniqueIds.size;
}
